export default class ProductFamily extends HTMLElement {
  connectedCallback() {
    import('./product-family.vue.component')
      .then(({
        Vue,
        default: productFamilyVueComponent,
      }) => {
        this.createVueInstance(Vue, productFamilyVueComponent);
      });
  }

  // eslint-disable-next-line class-methods-use-this
  createVueInstance(Vue, productFamilyVueComponent) {
    const gridRow = this.closest('.ents-reco-container__grid-row');

    // eslint-disable-next-line no-param-reassign
    Vue.config.ignoredElements = [
      /^shop-/,
      /^ents-/,
      /^ents-/,
      /^suchen-/,
      /^kaufen-click-and-reserve/,
      /^brtn-/,
    ];

    const component = productFamilyVueComponent(this, gridRow);
    return new Vue(component);
  }
}

document.addEventListener('bewe:ents:vue-ready', () => {
  customElements.define('ents-product-family', ProductFamily);
}, { once: true });
